import React from 'react';

export default function Notification({
  children,
  type = 'info',
  display = 'inline',
  ...props,
}) {
  return (
    <p className={`${type}-${display} with-icon-before`} {...props} >
      { children }
    </p>
  );
}



// WEBPACK FOOTER //
// ./src/universal/ui/components/Notification.js